"use client"
import { useEffect, useState } from "react";
import { IoStar } from "react-icons/io5";
import { AddReview } from "./addReview/AddReview";
import { DeleteProduct, getAllReviews } from "@/API/response";
import { useDispatch, useSelector } from "react-redux";
import { deleteReview, getReviewStart, getReviewSuccess } from "@/GlobalRedux/Slices/allReviews";
import Skeleton from "react-loading-skeleton";
import { FaTrash } from "react-icons/fa";
import { useRouter } from "next/navigation";


export default function ProductReviews({productID, ReviewData}) {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedImage, setSelectedImage] = useState(null);
    const router = useRouter()
    const { isUser } = useSelector((state) => state.currUser)
    const dispatch = useDispatch()
    // console.log("current User",isUser)
    const deleteReviewFunc = async (id)=>{
      // console.log("id",id)
      try {
        const res = await DeleteProduct(`review/${id}`,isUser?.token)
        console.log("response -->>>",res)
        if(res.message=="Token is not valid"){
          router.push("/login")
        }else{
          dispatch(deleteReview(id))
        }
        
        console.log("res",res)
      } catch (error) {
        console.log(error)
      }
    }
    const getAllReview = async()=>{
      try {
        dispatch(getReviewStart())
        // const res = await getAllReviews(`${productID}`)
        dispatch(getReviewSuccess(ReviewData))
        
      } catch (error) {
        console.log("error",error)
      }
    }
  const { allReviews, isLoader } = useSelector((state) => state.allReview);
// console.log("allReviews-->>", allReviews)
    useEffect(()=>{
        getAllReview()
    },[])
  return (
    <div className={allReviews.length === 0 ? "" : "max-w-6xl mx-auto p-2"}>
    <span className="flex justify-between items-center">
      <h1 className="text-2xl font-bold mb-4">Customer Reviews</h1>
      <h4
        className="font-bold text-gray-800 text-sm mb-4 hover:cursor-pointer hover:underline"
        onClick={() => setIsModalOpen(true)}
      >
        Write a Review
      </h4>
    </span>

    <div className="space-y-6">
      {isLoader
        ? [...Array(5)].map((_, index) => (
            <div
              key={index}
              className="border border-gray-300 p-4 rounded-lg shadow-md bg-white"
            >
              <div className="flex justify-between">
                <div className="flex items-center gap-2">
                  <Skeleton width={100} height={20} />
                </div>
                <Skeleton width={50} height={15} />
              </div>
              <Skeleton count={2} />
              <div className="flex items-center text-gray-500 text-sm mt-3">
                <Skeleton width={60} height={60} circle />
                <Skeleton width={60} height={60} circle />
              </div>
            </div>
          ))
        : allReviews?.map((review, index) => (
            <div
              key={index}
              className="border border-gray-300 p-4 rounded-lg shadow-md bg-white"
            >
              <div className="flex justify-between">
                <div>
                  <div className="flex items-center gap-2">
                    <span className="font-semibold text-lg">{review?.name}</span>
                  </div>
                  <div className="flex items-center mt-1">
                    {[...Array(5)].map((_, i) => (
                      <IoStar
                        key={i}
                        size={28}
                        className={i < review.star ? "text-yellow-700" : "text-gray-300"}
                      />
                    ))}
                  </div>
                </div>
                <span className="text-gray-500 text-sm">
                  {new Date(review?.updatedAt)
                    .toLocaleDateString("en-CA")
                    .split("-")
                    .reverse()
                    .join("-")}
                </span>
              </div>
              <p className="text-gray-700 mt-2">{review.description}</p>
              <div className="flex items-center text-gray-500 text-sm mt-3 justify-between">
                <span className="flex gap-2">
                  {review?.images &&
                    review?.images?.map((img, index) => (
                      <img
                        key={index}
                        src={img}
                        alt="review"
                        className="w-16 h-16 object-cover rounded-md cursor-pointer"
                        onClick={() => setSelectedImage(img)}
                      />
                    ))}
                </span>

                {isUser && isUser.userName && (
                  <FaTrash
                    className="h-6 w-6 text-red-400 hover:cursor-pointer"
                    onClick={() => deleteReviewFunc(review._id)}
                  />
                )}
              </div>
            </div>
          ))}
    </div>

    {isModalOpen && (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
        <div className="bg-white p-6 rounded-lg shadow-lg w-[90%] max-w-lg relative">
          <button
            className="absolute top-2 right-2 text-gray-600 hover:text-gray-900"
            onClick={() => setIsModalOpen(false)}
          >
            ✖
          </button>
          <AddReview setIsModalOpen={setIsModalOpen} isModalOpen={isModalOpen} productID={productID} />
        </div>
      </div>
    )}

    {selectedImage && (
      <div
        className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50"
        onClick={() => setSelectedImage(null)}
      >
        <div className="relative">
          <img src={selectedImage} alt="Selected Review" className="max-w-full h-96 sm:max-h-[90vh] rounded-lg" />
          <button
            className="absolute top-2 right-2 text-red-400 text-2xl"
            onClick={() => setSelectedImage(null)}
          >
            ✖
          </button>
        </div>
      </div>
    )}
  </div>
  );
}
